import {Component, Input, OnChanges} from '@angular/core';
import {NgClass} from '@angular/common';
import {Tooltip} from 'primeng/tooltip';

export interface MiniHorizontalStackChartItem {
    label: string;
    value: number;
    color?: string;
    textColor?: string;
}

@Component({
    selector: 'wm-mini-horizontag-stack-chart',
    templateUrl: './mini-horizontal-stack-chart.component.html',
    styleUrls: ['./mini-horizontal-stack-chart.component.less'],
    standalone: true,
    imports: [
        Tooltip
    ]
})
export class MiniHorizontalStackChartComponent {
    @Input() items: MiniHorizontalStackChartItem[] = [];

    percentages: number[] = [];

    ngOnChanges() {
        this.calculatePercentages();
    }

    calculatePercentages() {
        const total = this.items.reduce((sum, item) => sum + item.value, 0);
        this.percentages = this.items.map(item => (item.value / total) * 100);
    }

    makeTooltip(): string {
        return this.items.map(item => `${item.label}: ${item.value}`).join(', ');
    }
}